export default "__VITE_ASSET__8TID53eW__"